import {LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from '../constants/auth';

let savedUser = localStorage.getItem("logged_user");
const person = savedUser && JSON.parse(savedUser);
console.log("🚀 ~ file: auth.js ~ line 5 ~ person", person);
const initialState = {
    isAuthenticated: false,
    loginData: {},
    token: person?.info?.authenticationToken,
    studentId: person?.info?.personId,
    isError: false,
    errorMessage: ""  
}

export default function auth(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case LOGIN_SUCCESS:
            localStorage.setItem("logged_user", JSON.stringify({
                info: payload,
                isAuthenticated: true
            }));
            localStorage.setItem(`review_done`, "false");
            return {
                ...state,
                isAuthenticated: true,
                isError: false,
                loginData: payload,
                token:  payload.authenticationToken
            }
            
        case LOGIN_FAIL:
            return {
                ...state,
                isAuthenticated: false,
                isError: true,
                loginData: {},
                token:  null,
                errorMessage: payload
            }
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                isError: false,
                loginData: {},
                studentId: null,
                token:  null
            }

        default:
            return state;
    }
}